import { types } from 'mobx-state-tree'
import { StatisticDataPoint } from './StatisticDataPoint'

export const StatisticalHistory = types.model('StatisticalHistory').props({
  stat_name: types.string,
  data_points: types.maybeNull(types.array(StatisticDataPoint)),
})
